import { render, staticRenderFns } from "./ImageItem3.vue?vue&type=template&id=0c27a6e1"
import script from "./ImageItem3.vue?vue&type=script&lang=js"
export * from "./ImageItem3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports